// base rc-virtual-list 3.4.13
import List from './List';
export default List;